<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    level?: '1' | '2' | '3' | '4' | '5' | '6' | 'sub' | 'strong'
    sectioning?: boolean
  }>(),
  {
    level: '4',
    sectioning: true,
  },
)

const component = computed(() => {
  if (props.level === 'sub') return 'div'
  if (props.level === 'strong') return 'strong'
  return `h${props.level}`
})
const classes = computed(() => {
  if (!props.sectioning) return undefined

  switch (props.level) {
    case 'sub':
      return 'sub mt-6 mb-4'
    case 'strong':
      return 'mt-6 mb-4'
    default:
      return 'mb-4'
  }
})

const attrsWithoutClass = useAttrsWithout('class')
</script>

<template>
  <component
    :is="component"
    :class="twMerge(classes, String($attrs.class ?? ''))"
    v-bind="attrsWithoutClass"
  >
    <slot />
  </component>
</template>
